// extracted by mini-css-extract-plugin
var _1 = "CalendarGrid-moduleCalendarGrid__duCZS";
var _2 = "CalendarGrid-moduleboard__lp3Aq";
var _3 = "CalendarGrid-modulebody__ChogD";
var _4 = "CalendarGrid-modulebodyMessage__WXHEc CalendarGridBodyMessage-moduleCalendarGridBodyMessage__w70n9";
var _5 = "CalendarGrid-moduleloading__I9JoR";
export { _1 as "CalendarGrid", _2 as "board", _3 as "body", _4 as "bodyMessage", _5 as "loading" }
